/**
 * Polyfills for Node 12 compatibility
 * This file imports necessary polyfills from core-js to ensure compatibility with Node 12
 */

// Import specific polyfills needed for Node 12
import 'core-js/features/array/flat';
import 'core-js/features/array/flat-map';
import 'core-js/features/object/from-entries';
import 'core-js/features/promise/finally';
import 'core-js/features/string/match-all';
import 'core-js/features/string/replace-all';
import 'core-js/features/symbol/description';

// Optional: Import all stable polyfills if needed
// import 'core-js/stable';

// Export nothing - this file is only for side effects
export {};
